export const ORGANIZATION_ROLES = {
  ORG_OWNER: 'Org Owner',
  STAFF: 'Staff',
};